import { useState, useEffect, useCallback } from 'react';

var EC2 = 'https://api.algrok.com';
var LAMBDA = 'https://48vj6t5trl.execute-api.ap-south-1.amazonaws.com/prod';

function nowIST(){return new Date(new Date().toLocaleString('en-US',{timeZone:'Asia/Kolkata'}));}
function fmtTime(iso){if(!iso)return'--';try{return new Date(iso).toLocaleTimeString('en-IN',{timeZone:'Asia/Kolkata',hour:'2-digit',minute:'2-digit',second:'2-digit'});}catch(e){return'--';}}
function fmtDate(iso){if(!iso)return'--';try{return new Date(iso).toLocaleDateString('en-IN',{timeZone:'Asia/Kolkata',day:'2-digit',month:'short',year:'numeric'});}catch(e){return'--';}}

export default function TokenSetupM(){
  var [status,setStatus]=useState(null);
  var [health,setHealth]=useState(null);
  var [loading,setLoading]=useState(true);
  var [loginLoading,setLoginLoading]=useState(false);
  var [msg,setMsg]=useState('');
  var [msgType,setMsgType]=useState('');

  var fetchStatus=useCallback(function(){
    fetch(EC2+'/health',{signal:AbortSignal.timeout(3000)}).then(function(r){return r.json();}).then(function(d){setHealth(d);}).catch(function(){setHealth({status:'offline'});});
    fetch(EC2+'/token-status',{signal:AbortSignal.timeout(5000)}).then(function(r){return r.json();}).then(function(d){if(!d.error){setStatus(d);setLoading(false);}}).catch(function(){
      fetch(LAMBDA+'/token-status',{signal:AbortSignal.timeout(8000)}).then(function(r){return r.json();}).then(function(d){setStatus(d);setLoading(false);}).catch(function(){setLoading(false);});
    });
  },[]);
  useEffect(function(){fetchStatus();},[fetchStatus]);

  var refreshAndWaitForWS=function(successMsg){
    setMsg('\u27F3 Reloading token + reconnecting WebSocket...');setMsgType('info');
    return fetch(EC2+'/refresh',{signal:AbortSignal.timeout(15000)}).then(function(r){return r.json();}).then(function(d){
      if(d.status!=='ok')throw new Error(d.message||'Refresh failed');
      setMsg('\u27F3 Token reloaded \u2014 waiting for WebSocket...');
      return new Promise(function(resolve){
        var att=0;var pollWS=setInterval(function(){att++;
          fetch(EC2+'/health',{signal:AbortSignal.timeout(2000)}).then(function(r){return r.json();}).then(function(h){
            if(h.ws_connected){clearInterval(pollWS);setMsg(successMsg||'\u2713 Connected!');setMsgType('success');setHealth(h);resolve(true);}
            else if(att>=20){clearInterval(pollWS);setMsg('\u2713 Token refreshed, WS reconnecting...');setMsgType('success');resolve(false);}
          }).catch(function(){if(att>=20){clearInterval(pollWS);resolve(false);}});
        },1000);
      });
    }).catch(function(e){setMsg('\u2717 Refresh error: '+e.message);setMsgType('error');}).finally(function(){fetchStatus();});
  };

  var doQuickLogin=function(){
    setLoginLoading(true);setMsg('\u27F3 Running auto-login on EC2... (~15s)');setMsgType('info');
    fetch(EC2+'/playwright-login',{signal:AbortSignal.timeout(60000)}).then(function(r){return r.json();}).then(function(d){
      if(d.status==='success'){setMsg('\u2713 Auto-login done! Verifying...');setMsgType('info');
        return fetch(EC2+'/health',{signal:AbortSignal.timeout(3000)}).then(function(r){return r.json();}).then(function(h){
          if(h.ws_connected){setMsg('\u2713 Auto-login complete! '+(d.user||'')+' | WS connected!');setMsgType('success');setHealth(h);fetchStatus();}
          else{return refreshAndWaitForWS('\u2713 Auto-login done! WS reconnected!');}
        }).catch(function(){return refreshAndWaitForWS('\u2713 Auto-login done! Reconnecting...');});
      }else{throw new Error(d.error||'Unknown error');}
    }).catch(function(e){
      setMsg('EC2 unavailable, trying Lambda...');
      return fetch(LAMBDA+'/manual-login',{method:'POST',headers:{'Content-Type':'application/json'},body:'{}'}).then(function(r){return r.json();}).then(function(d){
        if(d.status==='success'){setMsg('\u2713 Login done! Refreshing...');setMsgType('info');return refreshAndWaitForWS('\u2713 Login complete! '+(d.user||''));}
        else{setMsg('\u2717 Login failed: '+(d.error||'Unknown'));setMsgType('error');}
      }).catch(function(e2){setMsg('\u2717 All login methods failed: '+e2.message);setMsgType('error');});
    }).finally(function(){setLoginLoading(false);});
  };

  var doFullLogin=function(){
    var apiKey='pet8g3l8tnzwxlgg';
    var oauthUrl='https://kite.trade/connect/login?api_key='+apiKey+'&v=3';
    var popup=window.open(oauthUrl,'KiteLogin','width=500,height=650,left=400,top=80');
    if(!popup){setMsg('\u2717 Popup blocked! Allow popups and retry.');setMsgType('error');return;}
    setMsg('\uD83C\uDF10 Zerodha login popup opened \u2014 complete login there...');setMsgType('info');setLoginLoading(true);
    var pollCount=0;var detected=false;
    var poll=setInterval(function(){pollCount++;
      try{
        if(popup.closed&&!detected){clearInterval(poll);
          setMsg('\u27F3 Popup closed \u2014 checking token exchange...');
          setTimeout(function(){
            fetch(EC2+'/health',{signal:AbortSignal.timeout(3000)}).then(function(r){return r.json();}).then(function(h){
              if(h.ws_connected){setMsg('\u2713 Full login complete! WS connected!');setMsgType('success');setHealth(h);fetchStatus();}
              else{refreshAndWaitForWS('\u2713 Login done! WS reconnected!');}
            }).catch(function(){setMsg('\u2717 Could not verify login. Try Force Refresh.');setMsgType('error');});
            setLoginLoading(false);
          },2000);
          return;
        }
        var loc=popup.location.href;
        if(loc&&(loc.indexOf('request_token')>=0||loc.indexOf('oauth-callback')>=0)){
          detected=true;clearInterval(poll);popup.close();
          setMsg('\u2713 Token received! Refreshing engine...');setMsgType('info');
          refreshAndWaitForWS('\u2713 Full login complete!').finally(function(){setLoginLoading(false);});
        }
      }catch(e){}
      if(pollCount>=120){clearInterval(poll);setMsg('\u2717 Login timeout (2 min). Try again.');setMsgType('error');setLoginLoading(false);}
    },1000);
  };

  var doForceRefresh=function(){
    setLoginLoading(true);setMsg('\u27F3 Reloading token + reconnecting WebSocket...');setMsgType('info');
    fetch(EC2+'/refresh',{signal:AbortSignal.timeout(15000)}).then(function(r){return r.json();}).then(function(d){
      if(d.status==='ok'){setMsg('\u2713 Token reloaded! WS reconnecting...');setMsgType('success');}
      else{setMsg('\u2717 Refresh failed: '+(d.message||JSON.stringify(d)));setMsgType('error');}
    }).catch(function(e){setMsg('\u2717 Refresh error: '+e.message);setMsgType('error');}).finally(function(){setLoginLoading(false);setTimeout(fetchStatus,3000);});
  };

  var G='#00d4aa',R='#ff4466',Y='#fbbf24',M='#4a5c72',T='#e2e8f0',BD='rgba(26,45,74,0.35)',CD='rgba(12,18,32,0.95)';
  var wsOk=health?health.ws_connected:false;
  var isFresh=status?status.fresh:false;
  var ec2Ok=health&&health.status!=='offline';
  var msgColor=msgType==='success'?G:msgType==='error'?R:'#0ea5e9';

  return(
  <div style={{minHeight:'100vh',background:'#05080f',color:T,fontFamily:"system-ui,sans-serif",paddingTop:'env(safe-area-inset-top,0)',paddingBottom:70,overflowX:'hidden'}}>
    <div style={{padding:'14px 16px 10px',borderBottom:'1px solid '+BD}}>
      <span style={{fontSize:15,fontWeight:800}}>Token Setup</span>
    </div>

    {/* Status Card */}
    <div style={{margin:12,background:CD,borderRadius:14,border:'1px solid '+BD,padding:16}}>
      <div style={{display:'flex',alignItems:'center',gap:12,marginBottom:16}}>
        <div style={{width:48,height:48,borderRadius:'50%',background:(isFresh&&wsOk?G:R)+'15',border:'2px solid '+(isFresh&&wsOk?G:R)+'40',display:'flex',alignItems:'center',justifyContent:'center'}}>
          <div style={{width:12,height:12,borderRadius:'50%',background:isFresh&&wsOk?G:R,boxShadow:isFresh&&wsOk?'0 0 10px '+G:'none'}}/>
        </div>
        <div>
          <div style={{fontSize:16,fontWeight:800,color:isFresh&&wsOk?G:R}}>{isFresh&&wsOk?'Connected':'Not Connected'}</div>
          <div style={{fontSize:10,color:M}}>{isFresh?'Token valid':'Token expired or missing'}{wsOk?' · WS active':''}</div>
        </div>
      </div>
      <div style={{borderTop:'1px solid rgba(26,45,74,0.2)',paddingTop:12}}>
        {[
          {l:'User',v:status?status.user_name||'--':'--'},
          {l:'Login method',v:status?status.login_method||'--':'--',c:G},
          {l:'Last refresh',v:status&&status.refreshed_at?fmtDate(status.refreshed_at)+' '+fmtTime(status.refreshed_at):'--'},
          {l:'WebSocket',v:wsOk?'\u25CF Connected':'\u25CB Disconnected',c:wsOk?G:R},
          {l:'EC2',v:ec2Ok?'\u25CF Online':'\u25CB Offline',c:ec2Ok?G:R},
        ].map(function(row){return<div key={row.l} style={{display:'flex',justifyContent:'space-between',padding:'6px 0',borderBottom:'1px solid rgba(26,45,74,0.1)'}}>
          <span style={{fontSize:11,color:M}}>{row.l}</span>
          <span style={{fontSize:11,fontWeight:700,color:row.c||T}}>{row.v}</span>
        </div>;})}
      </div>
    </div>

    {/* Status Message */}
    {msg&&<div style={{margin:'0 12px 12px',padding:'10px 14px',borderRadius:12,background:msgColor+'12',border:'1px solid '+msgColor+'30',color:msgColor,fontSize:11,fontWeight:600}}>{msg}</div>}

    {/* 3 Action Buttons */}
    <div style={{margin:'0 12px',display:'flex',flexDirection:'column',gap:8}}>
      <div onClick={function(){if(!loginLoading)doQuickLogin();}} style={{padding:16,borderRadius:14,border:'1px solid '+G+'30',background:G+'08',textAlign:'center',opacity:loginLoading?0.5:1}}>
        <div style={{fontSize:14,fontWeight:800,color:G}}>{'\u26A1'} Quick Login</div>
        <div style={{fontSize:9,color:M,marginTop:3}}>Auto TOTP · No browser needed</div>
      </div>
      <div onClick={function(){if(!loginLoading)doFullLogin();}} style={{padding:16,borderRadius:14,border:'1px solid #0ea5e930',background:'#0ea5e908',textAlign:'center',opacity:loginLoading?0.5:1}}>
        <div style={{fontSize:14,fontWeight:800,color:'#0ea5e9'}}>{'\uD83D\uDD11'} Full Login</div>
        <div style={{fontSize:9,color:M,marginTop:3}}>Opens Kite login in browser</div>
      </div>
      <div onClick={function(){if(!loginLoading)doForceRefresh();}} style={{padding:16,borderRadius:14,border:'1px solid '+Y+'30',background:Y+'08',textAlign:'center',opacity:loginLoading?0.5:1}}>
        <div style={{fontSize:14,fontWeight:800,color:Y}}>{'\uD83D\uDD04'} Force Refresh</div>
        <div style={{fontSize:9,color:M,marginTop:3}}>Re-fetch token · Restart WebSocket</div>
      </div>
    </div>

    {/* Refresh status */}
    <div style={{margin:12,textAlign:'center'}}>
      <div onClick={function(){fetchStatus();}} style={{fontSize:11,color:'#0ea5e9',fontWeight:700,padding:8}}>{'\u21BB'} Refresh Status</div>
    </div>
  </div>);
}
